var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:_vm.size,style:(_vm.wrapperStyles),attrs:{"id":"map-wrapper"}},[_c('div',{staticStyle:{"height":"100%","width":"100%"},attrs:{"id":_vm.id}},[_c('div',{staticClass:"google-map",attrs:{"id":"google-map-container"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }